import { Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { dsEnums } from '@vectronic/openApi-customer';
import { FormlyScheduleControlComponent } from './formly-schedule-control.component';

export interface ScheduleProps extends FormlyFieldProps {
  scheduleType: dsEnums.ScheduleType;
}

export interface FormlyScheduleFieldConfig extends FormlyFieldConfig<ScheduleProps> {
  type: 'schedule' | Type<FormlyScheduleComponent>;
}

@Component({
  selector: 'vectronic-formly-schedule-wrapper',
  imports: [FormlyScheduleControlComponent, ReactiveFormsModule],
  template: `
    <vectronic-formly-schedule-control
      [formControl]="formControl"
      [scheduleType]="props.scheduleType"
      [scheduleTitles]="scheduleTitles"
    ></vectronic-formly-schedule-control>
  `,
})
export class FormlyScheduleComponent extends FieldType<FieldTypeConfig<ScheduleProps>> {
  get scheduleTitles(): Record<dsEnums.ScheduleType, string> | undefined {
    if (this.props.label && this.props.scheduleType) {
      return {
        [this.props.scheduleType]: this.props.label,
      } as Record<dsEnums.ScheduleType, string>;
    }
    return undefined;
  }
}
